<template>
  <Grid
    :pageable="false"
    :resizable="true"
    :reorderable="true"
    :sortable="false"
    :row-height="25"
    :data-items="parts"
    :columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
    @columnresize="handleColumnResize"
    @columnreorder="handleColumnReorder"
    class="parts-grid"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';

import fields from './fields';

export default {
  data: () => ({
    prepareColumnsData,
    fields,
  }),
  computed: {
    ...mapGetters('rfps', ['selectedRfpId']),
    ...mapGetters('rfpDetails', ['partsById']),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(GRID_ID.RFP_GRID_PARTS);
    },
    parts() {
      return this.partsById(this.selectedRfpId);
    },
  },
  methods: {
    ...mapActions('rfpDetails', ['getParts']),
    ...mapActions('account', ['saveGridSettings']),
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: GRID_ID.RFP_GRID_PARTS, settings: { columns: newColumns }});
    }, 500),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: GRID_ID.RFP_GRID_PARTS, settings: { columns: newColumns }});
    },
  },
  watch: {
    selectedRfpId() {
      this.getParts(this.selectedRfpId);
    },
  },
  mounted() {
    this.getParts(this.selectedRfpId);
  },
};
</script>

<style>
.parts-grid {
  height: auto !important;
}
</style>
